"use client";

import { useId, useState, useEffect } from "react";

/**
 * useUuid is a hook that generates a unique identifier for a component.
 * Returns the provided id if given, otherwise generates a stable ID using React's useId.
 *
 * To avoid hydration mismatches, this hook returns an empty string during SSR
 * and initial hydration, then updates to the actual ID after mount.
 *
 * @param id
 * Optional custom ID to use instead of generating one
 */
export function useUuid(id?: string): string {
  const generatedId = useId();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Return custom id if provided
  if (id) {
    return id;
  }

  // Return empty string during SSR/hydration to avoid mismatch
  // The ID will be set after hydration completes
  return mounted ? generatedId : "";
}
